import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface DaysLeftInTrialState {
  daysLeftInTrial: number | null;
}

const daysLeftInTrial: Module<DaysLeftInTrialState, RootState> = {
  namespaced: true,
  state: {
    daysLeftInTrial: null,
  } as DaysLeftInTrialState,
  mutations: {
    setValue(state: DaysLeftInTrialState, value: { days: number }): void {
      state.daysLeftInTrial = value.days;
    },
  },
};

export default daysLeftInTrial;
